import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a3aa49ff711180014cc19c4_1782342797286_0c31268c/innobox/src/app/servicios/asesoria-consultoria/page.tsx");
